<mulo-notify-bell
    [ariaLabel]="'research.header.outputClaim.a11yLabel' | translate: { count: notifySvc.totalCount() }"
    [count]="notifySvc.totalCount()"
    (click)="toggleMenu()"
    cdkOverlayOrigin
    #trigger="cdkOverlayOrigin"
></mulo-notify-bell>
<ng-template
    cdkConnectedOverlay
    [cdkConnectedOverlayOrigin]="trigger"
    [cdkConnectedOverlayOpen]="menuOpen()"
    (detach)="closeMenu()"
    (overlayOutsideClick)="closeMenu()"
>
    <div class="menu-container mat-elevation-z4">
        <h2>{{ 'research.header.outputClaim.a11yLabel' | translate: { count: notifySvc.totalCount() } }}</h2>
        <mat-tab-group dynamicHeight mat-stretch-tabs="false">
            @if (claimOutputs()?.length > 0) {
                <mat-tab [label]="'research.outputClaim.tabTitle' | translate: { count: claimOutputs()?.length }">
                    @for (output of claimOutputs() | slice: 0 : itemLimit; track output) {
                        <mulo-brief
                            [hoverable]="false"
                            [titleCutoff]="true"
                            [title]="output.title"
                            class="notify-menu-item"
                            [type]="output.resourceType | translate"
                        >
                            @if (output.creators?.length === 1) {
                                <div class="notify-authors">
                                    {{ output.creators }}
                                </div>
                            }
                            @if (output.creators?.length > 1) {
                                <div class="notify-authors">
                                    {{ output.creators.slice(0, -1).join(', ') + ' and ' + output.creators.slice(-1) }}
                                </div>
                            }
                            <div class="notify-time">{{ output.dateObject | amTimeAgo }}</div>
                        </mulo-brief>
                    }
                    <button
                        mat-flat-button
                        class="notify-menu-c2a"
                        routerLink="notifications/outputClaim"
                        queryParamsHandling="merge"
                        (click)="closeMenu()"
                    >
                        {{ 'research.notifications.outputClaim.viewAll' | translate }}
                    </button>
                </mat-tab>
            }
            @if (requests()?.length > 0) {
                <mat-tab [label]="'research.requests.tabTitle' | translate: { count: requests().length }">
                    @for (request of requests() | slice: 0 : itemLimit; track request.id) {
                        <mulo-brief
                            [titleCutoff]="true"
                            [title]="request.assetTitle"
                            class="notify-menu-item"
                            [type]="request.assetType | translate"
                            routerLinkUrl="notifications/requests"
                            [queryParams]="{ institution }"
                            [fragment]="'request-' + request.id"
                        >
                            <div class="notify-authors">{{ request.requester }}</div>
                            <div class="notify-time">{{ request.date | amTimeAgo }}</div>
                        </mulo-brief>
                    }
                    <button
                        mat-flat-button
                        class="notify-menu-c2a"
                        routerLink="notifications/requests"
                        queryParamsHandling="merge"
                        (click)="closeMenu()"
                    >
                        {{ 'research.notifications.requests.viewAll' | translate }}
                    </button>
                </mat-tab>
            }
        </mat-tab-group>
    </div>
</ng-template>
